export class AbstractComponent {
    public init() {
        //
    }
}
